export const brushes = process.env.PUBLIC_URL + '/assets/brushes.png'

export const team = [
    {
        id: 1,
        alt: 'person 1',
        img: '/assets/person1.jpg',
    },
    {
        id: 2,
        alt: 'person 2',
        img: '/assets/person2.jpg',
    },  
    {
        id: 3,
        alt: 'person 3',
        img: '/assets/person3.jpg',
    },
]
